import currencies from './currencies';

export default class MoneyCurrency {
  constructor(name) {
    const currencyKey = name.toLowerCase();
    const currency = currencies[currencyKey];

    this.name = currency.name;
    this.isoCode = currency.isoCode;
    this.symbol = currency.symbol;
    this.decimalMark = currency.decimalMark;
    this.thousandsSeparator = currency.thousandsSeparator;
  }
}
